import useMediaQueries from '@stone/hooks/useMediaQueries';
import useProductsList from '@stone/hooks/useProductsList';
import CarouselNavigation from '@stone/ui/button/CarouselNavigation';
import classNames from 'classnames';
import React, { useEffect, useMemo } from 'react';
import IconGalleryCarousel from './IconGalleryCarousel';
import ProductTilesListcontext from '@stone/scripts/contexts/ProductTilesListContext';
import '@stone/scss/components/gallery/_gallery.scss';
import { compileListName } from '@stone/utils/analytics';
const IconGallery = (props) => {
    // const category = JSON.parse(props?.category);
    // ANCHOR - HOOKS --------------------------------------------------------------------
    let listname = compileListName(props.itemListName || 'icon gallery');
    const { parseCategory, getProducts, resetProducts, products } = useProductsList(listname, props === null || props === void 0 ? void 0 : props.limit);
    const { isDesktop, isTouch, isWideDesktop } = useMediaQueries();
    // ANCHOR - COSTANTS --------------------------------------------------------------------
    const category = parseCategory(props);
    const dClasses = 'd-flex justify-end align-top';
    const editorialItems = useMemo(() => props.isEditorial && props.editorialItems && JSON.parse(props.editorialItems), [props]);
    const swiperDefaults = {
        slidesPerView: 'auto',
        watchSlidesProgress: true,
    };
    // ANCHOR - USE MEMO --------------------------------------------------------------------
    const isCarouselTouch = useMemo(() => !isDesktop || (isTouch && !isWideDesktop), [isDesktop, isTouch, isWideDesktop]);
    const listContext = useMemo(() => {
        let context = {};
        context.analyticsData = {
            item_list_name: listname,
        };
        return context;
    }, [props.itemListName]);
    // ANCHOR - USE EFFECT --------------------------------------------------------------------
    useEffect(() => {
        if (category && !props.isEditorial) {
            getProducts(category);
        }
        return () => resetProducts();
    }, []);
    // ANCHOR - COMPONENTS --------------------------------------------------------------------
    const renderLink = () => (React.createElement("a", { href: props.linkUrl, className: "button button--tertiary", "aria-label": props.linkLabelA11n },
        React.createElement("span", null, props.linkLabel)));
    const renderNavigation = () => React.createElement(CarouselNavigation, { id: `gallery-${props.uuid}` });
    // ANCHOR - RENDER --------------------------------------------------------------------
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "gallery" },
            React.createElement("div", { className: "gallery__intro" },
                React.createElement("div", { className: "container" },
                    React.createElement("div", { className: "row row-gap-24" },
                        React.createElement("div", { className: classNames('col-lg-4', { 'd-flex justify-between align-middle': !isDesktop }) },
                            React.createElement("h2", { className: "font__title" }, props.title),
                            !isDesktop && renderNavigation()),
                        React.createElement("div", { className: "col-lg-7" },
                            React.createElement("p", null, props.description)),
                        props.linkLabel && props.linkUrl && React.createElement("div", { className: `col-lg-7 offset-lg-${isCarouselTouch ? '4' : '6'} ${isDesktop ? dClasses : ''} ` }, renderLink()),
                        isCarouselTouch && isDesktop && (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: `col-lg-2 ${dClasses}` }, renderNavigation())))))),
            React.createElement(ProductTilesListcontext.Provider, { value: listContext },
                React.createElement("div", { className: "gallery__carousel" }, (!!(products === null || products === void 0 ? void 0 : products.length) || !!(editorialItems === null || editorialItems === void 0 ? void 0 : editorialItems.length)) && (React.createElement(React.Fragment, null,
                    React.createElement(IconGalleryCarousel, { id: props.uuid, products: products, editorialItems: editorialItems, swiperDefaults: swiperDefaults, hideCtas: props.hiddenCtas, hidePrices: props.hiddenPrices, isEditorial: props.isEditorial }),
                    ' ')))))));
};
export default IconGallery;
